var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a0e1b466-c661-4ca7-9ea9-b2e5c1cd6f0d",
    "data-name": "C-wires layered OFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 510.34 284.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".C-wire-channel,.efe41c5f-e8be-4b27-82a9-3c6fa83cffba{fill:none;}.C-wire-channel{stroke:#d2e4f9;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.efe41c5f-e8be-4b27-82a9-3c6fa83cffba{stroke:#b290d1;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a329133b-bb86-4262-8ade-0cd3cf646571",
    "data-name": "Channel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M22.83,209.34v47.37a4,4,0,0,0,4,4H158.51a4,4,0,0,0,2-.53L449.85,94.85a4,4,0,0,0,2-3.48V46.72a4,4,0,0,1,2-3.46l33.66-19.54"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "fa25fe65-9d35-4d00-9ba5-38712863fc1e",
    "data-name": "OFF"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M22.83,209.34v47.37a4,4,0,0,0,4,4H158.51a4,4,0,0,0,2-.53L449.85,94.85a4,4,0,0,0,2-3.48V46.72a4,4,0,0,1,2-3.46l33.66-19.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "efe41c5f-e8be-4b27-82a9-3c6fa83cffba",
    d: "M22.83,209.34v47.37a4,4,0,0,0,4,4H158.51a4,4,0,0,0,2-.53L449.85,94.85a4,4,0,0,0,2-3.48V46.72a4,4,0,0,1,2-3.46l33.66-19.54"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.99c1accb.svg";
export { ForwardRef as ReactComponent };